import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import type { HealthcareService } from "fhir/r3"

type FetchHealthcareServiceProps = {
  odsId?: string
  token?: string | null
}

export async function fetchHealthcareService({
  odsId,
  token,
}: FetchHealthcareServiceProps): Promise<HealthcareService> {
  const response = await fetch(`/api/healthcareservice/${odsId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.ok) {
    const healthcareService = await response.json()
    return healthcareService as HealthcareService
  }

  throw Error("healthcare service fetch failed")
}

export const useHealthcareServiceQuery = ({
  odsId,
  token,
}: FetchHealthcareServiceProps): UseQueryResult<HealthcareService> =>
  useQuery({
    queryKey: ["healthcareService", odsId],
    queryFn: async () => await fetchHealthcareService({ odsId, token }),
    enabled: !!token && !!odsId,
  })
